// import React from 'react';
namespace React { export type FC<T> = {}; export type ChangeEvent<T> = { target } };
const useEffect = React.useEffect;
const useRef = React.useRef;

import { DropDownBook, DropDownCategory } from '../models';

import { ReactBook, getFavoriteIcon } from './ReactBook';

interface CategoryProps
{
    initialized: boolean;
    categoryId: number;
    books: { [id: number]: DropDownBook };
    categories: { [id: number]: DropDownCategory };
    enableFavorites: boolean;
    enableFilter: boolean;
    filter: string;
    onCategorySelect: (category: DropDownCategory, checked: boolean) => void;
    onCategoryOpenClose: (category: DropDownCategory, isOpen: boolean) => void;
    onBookSelect: (book: DropDownBook, checked: boolean) => void;
    isRoot: boolean;
    onFilterChange?: (query: string) => void;
}

const ReactCategory: React.FC<CategoryProps> = ({
    initialized,
    categoryId,
    books,
    categories,
    enableFavorites,
    enableFilter,
    filter,
    onCategorySelect,
    onCategoryOpenClose,
    onBookSelect,
    onFilterChange,
    isRoot,
}) =>
{
    let category: DropDownCategory = categories[categoryId];

    // initialized = false, categoryId = null
    if (!category) {
        // @ts-ignore
        category = {
            // name: 'dummy1',
            bookIds: [],
            subcategoryIds: [],
        };
    }

    const isOpen: boolean = category.isOpen;

    const Localized = window['FluentReact'].Localized;

    const checkboxRef = useRef();

    const handleToggle = (e) =>
    {
        // NOTE: this onClick (on the div) happens before an onChange on the
        //       checkbox input
        //  XXX: this is the checkbox, ignore
        // if (e.target.tagName == 'INPUT')
        if (e.target === checkboxRef.current)
            return;

        onCategoryOpenClose(categoryId, !isOpen);

        // Don’t bubble from the toggle to the header bar (though it was benign).
        e.stopPropagation();
    };

    const handleCategorySelect = (e: React.ChangeEvent<HTMLInputElement>) =>
    {
        onCategorySelect(categoryId, e.target.checked);
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    {
        onFilterChange(e.target.value);
    };

    const handleClearFilter = (e) =>
    {
        onFilterChange('');
    }

    const handleFavoriteIconClick = (e) =>
    {
        console.info('TODO: favorite icon clicked:', category.name);
    }

    const toggleClassName = `glyphicon-chevron-${isOpen ? 'up' : 'down'}`;

    useEffect(() =>
    {
        checkboxRef.current.indeterminate = category.selected === null;
    });

    const checkbox = (
        <input
            type="checkbox"
            className={isRoot ? "" : "concrete-item-checkbox checkbox"}
            checked={category.selected ?? false}
            onChange={handleCategorySelect}
            ref={checkboxRef}
        />
    );

    const toggle = (
        <span
            className={isRoot ? "dropdown-select-more" : "concrete-item-more"}
        >
            <span className={`glyphicon ${toggleClassName}`}></span>
        </span>
    );

    // TODO: respect an arbitrary order of categories (modern first, period second)
    // TODO: sort modern dictionaries by priority, period ones by year published
    const bookIds = category.bookIds.filter((bookId) => bookId in books);

    const contents = isOpen && <>
        {category.subcategoryIds.map(subId => (
            // @ts-ignore
            <ReactCategory
                key={subId}
                categoryId={subId}
                books={books}
                categories={categories}
                enableFavorites={enableFavorites}
                onCategorySelect={onCategorySelect}
                onCategoryOpenClose={onCategoryOpenClose}
                onBookSelect={onBookSelect}
                isRoot={false}
            />
        ))}

        {bookIds.map(bookId => (
            // @ts-ignore
            <ReactBook
                key={bookId}
                bookId={bookId}
                books={books}
                enableFavorites={enableFavorites}
                onBookSelect={onBookSelect}
            />
        ))}
    </>;

    if (isRoot) {
        // like the one in DropDownSelect.headerLoader
        let loadingVisualization = getLoadingVisualization(initialized);

        const clearFilterIconClasses =
            'dropdown-clear-filter glyphicon glyphicon-remove-circle';

        const filterWidget = enableFilter ?
        <div className="dropdown-filter">
            <Localized id="filter-by-name" attrs={{ placeholder: true }}>
                <input
                    className="dropdown-filter-input"
                    // DONE: localize (originally: FilterByName)
                    placeholder="Filter by name, abbreviation, …"
                    value={filter}
                    onChange={handleFilterChange}
                />
            </Localized>

            <span
                className={clearFilterIconClasses}
                onClick={handleClearFilter}
            ></span>
        </div> : null;

        return <>
            <div className="dropdown-select-header" onClick={handleToggle}>
                <span className="dropdown-select-checkbox">{checkbox}</span>
                <span className="dropdown-select-text">{category.name}</span>
                {toggle}
                {loadingVisualization}
            </div>

            {isOpen &&
                <div className="dropdown-select-body child-items-visible">
                    {filterWidget}

                    {contents}
                </div>
            }
        </>;
    }

    const favoriteIcon = enableFavorites ?
        getFavoriteIcon({
            hasLabels: false,
            handleFavoriteIconClick,
        }) :
        null;

    return (
        <div className="concrete-item">
            {checkbox}

            <span
                className="category-toggle-and-name"
                onClick={handleToggle}
            >
                {toggle}

                <span className="concrete-item-name">{category.name}</span>
            </span>

            {favoriteIcon}

            <div className="child-items child-items-visible">
                {contents}
            </div>
        </div>
    );
};

// TODO: move somewhere common
const getLoadingVisualization = (initialized: boolean) =>
{
    if (initialized)
        return null;

    const classes =
        'lv-circles tiniest dropdown-loader-color dropdown-align-loader';

    const numParts = 12;
    const parts: Array<any> = [];

    for (let i = 0; i < numParts; i++) {
        parts.push(<div key={i} />);
    }

    return (
        <div className={classes}>
            {parts}
        </div>
    );
}

//  XXX: default exports are not supported by the loadUMD2GlobalHack
export { ReactCategory };
